import React, { FC } from 'react'
import Slider from 'react-slick'
import { TopicCard } from '../../../../models/topics/card'
import ImgUtil from '../../../../utils/img.utils'
import { isExternalURL } from '../../../../utils/link.utils'
import WrapperImage from '../../wrapperImage'
import { SLIDER_SETTINGS } from './sliderSettings'

type CardSliderImageProps = {
  cardData: TopicCard[]
  sliderRef: any
  imageCardNav: any
  setCurrentIndex: any
  currentIndex: number
  totalSlide: number
}

const addRemoveZero = (number: number) => {
  return number < 10 ? 0 : null
}

export const ImageCardSlider: FC<CardSliderImageProps> = ({
  cardData,
  sliderRef,
  imageCardNav,
  setCurrentIndex,
  currentIndex,
  totalSlide,
}) => {
  return (
    <>
      <Slider
        className="slider-nav"
        asNavFor={imageCardNav}
        {...SLIDER_SETTINGS.IMAGE_CARDS}
        afterChange={newIndex => {
          setCurrentIndex(newIndex + 1)
        }}
        ref={sliderRef}>
        {cardData?.length > 0 &&
          cardData.map((card, index: number) => {
            const iconLinkTarget = isExternalURL(card.ctaLink) ? '_blank' : '_self'
            return (
              <div className="CardSlider__Image-Card" key={index}>
                <div className="CardSlider__Image-Gradient">
                  <a
                    href={card.ctaLink}
                    target={iconLinkTarget}
                    className="CardSlider__Image-Link"></a>
                </div>
                <WrapperImage
                  src={ImgUtil.getResizedImageUrl(
                    card.image?.image?.file?.url,
                    `width=600, height=335`
                  )}
                  alt={card.image?.altText}
                  threshold={650}
                  className="bg-image"
                />
                {card.logoOverlay && (
                  <WrapperImage
                    src={ImgUtil.getResizedImageUrl(
                      card.logoOverlay?.image?.file?.url,
                      `width=600, height=335`
                    )}
                    alt={card.logoOverlay?.altText}
                    threshold={650}
                    className="logo"
                  />
                )}
              </div>
            )
          })}
      </Slider>
      <div className="CardSlider__Count">
        <div className="count-bar">
          <div className="current">
            {addRemoveZero(currentIndex)}
            {currentIndex}
          </div>
          <div className="total">
            {addRemoveZero(totalSlide)}
            {totalSlide}
          </div>
        </div>
      </div>
    </>
  )
}
